import {
  POST_BOOK_ORDER_LOADING,
  POST_BOOK_ORDER_DONE,
  POST_BOOK_ORDER_ERROR,

  POST_DATA_BOOK,
  POST_DATA_TEMP,

  POST_BOOK_CONTRACT_LOADING,
  POST_BOOK_CONTRACT_DONE,
  POST_BOOK_CONTRACT_ERROR,

  GET_TOTAL_PRICE_LOADING,
  GET_TOTAL_PRICE_DONE,
  GET_TOTAL_PRICE_ERROR
} from './actions'

export default {
  [POST_BOOK_ORDER_LOADING] (state) {
    state.isLoading = true
    state.items = []
  },

  [POST_BOOK_ORDER_DONE] (state, items) {
    state.items = items
    state.isLoading = false
    state.error = false
    localStorage.removeItem('bookingFormData')
    localStorage.removeItem('instantPriceData')
  },

  [POST_BOOK_ORDER_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [POST_DATA_BOOK] (state, items) {
    state.forms = items
  },

  [POST_DATA_TEMP] (state, items) {
    state.dataTemp = items
  },

  [POST_BOOK_CONTRACT_LOADING] (state) {
    state.isLoading = true
  },

  [POST_BOOK_CONTRACT_DONE] (state, items) {
    state.items = items
    state.isLoading = false
    localStorage.removeItem('bookingFormData')
  },

  [POST_BOOK_CONTRACT_ERROR] (state, error) {
    state.error = true
    state.isLoading = false
  },

  [GET_TOTAL_PRICE_LOADING] (state) {
    state.isLoadingTotalPrice = true
  },

  [GET_TOTAL_PRICE_DONE] (state, totalPrice) {
    state.totalPrice = totalPrice
    state.isLoadingTotalPrice = false
  },

  [GET_TOTAL_PRICE_ERROR] (state, errorTotalPrice) {
    state.errorTotalPrice = errorTotalPrice
    state.isLoadingTotalPrice = false
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/book/mutations.js